import React from 'react';
import { Paper } from '@mui/material';
import { UploadsList } from './UploadsList';

export function UploadsGetAll(props) {
  return (
    <Paper id="uploads-get-all" sx={{ boxShadow: 10, borderRadius: 1, p: 2 }}>
      <UploadsList {...props} />
    </Paper>
  )
};
